import { defineComponent } from 'vue';
import LocationsMapInputFields from '@/components/Locations/LocationsMapInputFields.vue';
import GoogleMaps from '@/components/Base/Maps/Locations/GoogleMaps.vue';
import LocationCard from '@/components/Locations/subComponents/LocationCard.vue';
import { mapState } from 'vuex';
import GreenGmapsClusterRenderer from '@/services/location/GreenGmapsClusterRenderer';
import eventBus from '@/services/EventBus';
export default defineComponent({
    name: 'locations-map-display',
    components: {
        LocationCard,
        LocationsMapInputFields,
        GoogleMaps,
    },
    data() {
        return {
            showMapsNotListing: true,
            clusterRenderer: new GreenGmapsClusterRenderer('#123645'),
            window_size_width: 0,
            showStoreList: false,
        };
    },
    methods: {
        storeWindowSize() {
            this.window_size_width = window.innerWidth;
        },
        startShowStoreList() {
            console.log('SHOW LIST');
            this.showStoreList = true;
        },
    },
    computed: Object.assign({ smallDisplay() {
            return this.window_size_width <= 767;
        } }, mapState('global', { locations: 'locations' })),
    mounted() {
        eventBus.on('googleMaps:mapLocationClicked', () => {
            this.startShowStoreList();
        });
        this.storeWindowSize();
        window.addEventListener('resize', this.storeWindowSize);
    },
    unmounted() {
        window.removeEventListener('resize', this.storeWindowSize);
    },
});
